import { type FC } from "react";

import { Button } from "@/shared/components/ui/button";
import { useGoogleOAuthEnabled } from "@/shared/hooks/useGoogleOAuthEnabled";
import googleIcon from "@/shared/assets/icons/google.svg";

interface GoogleOAuthSectionProps {
  label?: string;
  onGoogleClick: () => void;
}

export const GoogleOAuthSection: FC<GoogleOAuthSectionProps> = ({
  label = "Sign up with Google",
  onGoogleClick,
}) => {
  const isGoogleOAuthEnabled = useGoogleOAuthEnabled();

  if (!isGoogleOAuthEnabled) return null;

  return (
    <>
      <Button variant="outline" rounded={true} className="w-full gap-2" onClick={onGoogleClick}>
        <img src={googleIcon} alt="Google" className="h-4 w-4" />
        {label}
      </Button>

      <div className="flex items-center gap-4">
        <div className="h-px flex-1 bg-stone-200" />
        <span className="text-sm text-secondary">OR</span>
        <div className="h-px flex-1 bg-stone-200" />
      </div>
    </>
  );
};
